import { render } from "./IndexCompany.vue?vue&type=template&id=62b3c17c&scoped=true&ts=true"
import script from "./IndexCompany.vue?vue&type=script&lang=ts"
export * from "./IndexCompany.vue?vue&type=script&lang=ts"

import "./IndexCompany.vue?vue&type=style&index=0&id=62b3c17c&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b3c17c"]])

export default __exports__